// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"803":"6827d4a1","879":"905dc9c5"}[chunkId] + ".css";
};